export default {
	ball: '/game-images/pong/ball.png'
};
